import React, { useEffect, useState } from "react";
import { Table, Button } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useHistory, useParams, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import SideNav from "../../Sidenav";
import DemographicsPatientDetail from "../DemographicsPatientDetail";
import { GetSideNav } from "../../../StateManagement/Reducers/ScheduleState";
import axiosInstance from "../../../axios/axios";
import { Decrypt_Value, Encrypt_Value } from "../../../MiddleWare/EncryptDecrypt";
import "./Scoreboard.css";

const ActivityLog = () => {
  const history = useHistory();
  const { pid, sid } = useParams();
  const location = useLocation();

  const dispatch = useDispatch();
  const [navData1, setNavData1] = useState("iconclose");
  const NavData1 = useSelector((state) => state.Schedule?.NavData);

  const [formName, setFormName] = useState("");
  const [activityData, setActivityData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    dispatch(GetSideNav("demographics"));
  }, [dispatch]);

  useEffect(() => {
    if (NavData1 !== "") {
      setNavData1(NavData1);
    }
  }, [NavData1]);

  useEffect(() => {
    fetchActivityLog();
  }, [pid, sid]);

  const fetchActivityLog = async () => {
    if (!pid || !sid) return;
    try {
      setLoading(true);

      const response = await axiosInstance.get(
        `/vozo/get-activity-log?activity_module_id=${sid}`);

      if (response.data && response.data !== "") {
        const decrypted = Decrypt_Value(response.data, "vozo");
        const logsArray = Array.isArray(decrypted) ? decrypted : (decrypted?.activity_logs || []);

        if (logsArray && logsArray.length > 0) {
          setFormName(logsArray[0].screening_form || "Outcome Measure");

          const dtFormat = localStorage.getItem("dateFormat") || "MM/DD/YYYY";
          const formattedLogs = logsArray.map((log, index) => ({
            key: log.id?.toString() || index.toString(),
            dateTime: moment(log.created_at).format(dtFormat),
            userName: log.performed_by,
            userType: log.user_type,
            activityType: log.activity_message,
          }));
          setActivityData(formattedLogs);
        } else {
          setActivityData([]);
        }
      }
    } catch (error) {
      console.error("Error fetching activity log:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleBack = () => {
    history.goBack();
  };

  const columns = [
    {
      title: "Date & Time",
      dataIndex: "dateTime",
      key: "dateTime",
      width: "25%",
    },
    {
      title: "User Name",
      dataIndex: "userName",
      key: "userName",
      width: "25%",
    },
    {
      title: "User Type",
      dataIndex: "userType",
      key: "userType",
      width: "25%",
    },
    {
      title: "Activity Type",
      dataIndex: "activityType",
      key: "activityType",
      width: "25%",
    },
  ];

  return (
    <>
      <SideNav />
      <div
        className={
          navData1 === "iconopen"
            ? "nav_right  tl-mt-4 w-100 neg-marg-btm  m-r-13 "
            : "nav_right1  tl-mt-4 w-100 neg-marg-btm  m-r-13 "
        }
      >
        <div className="d-flex">
          <DemographicsPatientDetail />

          <div className="imm-main-block m-t-0 m-b-15 w-82-5">
            <div className="scoreboard-container" style={{ padding: "30px", minHeight: "80vh" }}>

              <div style={{ display: "flex", alignItems: "center", marginBottom: "30px" }}>
                <Button
                  type="text"
                  icon={<ArrowLeftOutlined />}
                  onClick={handleBack}
                  style={{ fontSize: "20px", marginRight: "10px", color: "#333", transform: "translateY(-8px)" }}
                />
                <h2 style={{ margin: 0, fontSize: "22px", fontWeight: "600", color: "#333" }}>
                  Activity Log {formName ? `(${formName})` : ""}
                </h2>
              </div>

              <div style={{ border: "1px solid #f0f0f0", borderRadius: "8px", overflow: "hidden" }}>
                <Table
                  columns={columns}
                  dataSource={activityData}
                  pagination={false}
                  loading={loading}
                  bordered={false}
                  rowClassName={() => "activity-log-row"}
                  scroll={{ x: 'max-content' }}
                />
              </div>

            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ActivityLog;
